<div class="graph-error-state">
  @if (showIcon) {
    <svg [attr.width]="iconSize" [attr.height]="iconSize" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.2"
        d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
        fill="#FF7F00" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M24 7.5C14.8873 7.5 7.5 14.8873 7.5 24C7.5 33.1127 14.8873 40.5 24 40.5C33.1127 40.5 40.5 33.1127 40.5 24C40.5 14.8873 33.1127 7.5 24 7.5ZM4.5 24C4.5 13.2304 13.2304 4.5 24 4.5C34.7696 4.5 43.5 13.2304 43.5 24C43.5 34.7696 34.7696 43.5 24 43.5C13.2304 43.5 4.5 34.7696 4.5 24Z"
        fill="#FF7F00" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M24 13.5C24.8284 13.5 25.5 14.1716 25.5 15V25.5C25.5 26.3284 24.8284 27 24 27C23.1716 27 22.5 26.3284 22.5 25.5V15C22.5 14.1716 23.1716 13.5 24 13.5Z"
        fill="#FF7F00" />
      <path
        d="M24 34.5C25.2426 34.5 26.25 33.4926 26.25 32.25C26.25 31.0074 25.2426 30 24 30C22.7574 30 21.75 31.0074 21.75 32.25C21.75 33.4926 22.7574 34.5 24 34.5Z"
        fill="#FF7F00" />
    </svg>
  }
  <span class="graph-error-state__message-main">{{ errorMessage }}</span>
  <span class="graph-error-state__message-secondary">{{ subMessage }}</span>
</div>